export default "__VITE_ASSET__19dd928d__"